import { CdkDrag, CdkDragEnd, CdkDragMove } from '@angular/cdk/drag-drop';
import { CdkMenuModule } from '@angular/cdk/menu';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, TemplateRef } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import { Material } from '../../../../../classes/material.class';
import { Planning } from '../../../../../classes/planning.class';
import { CodaltComponent } from '../../../../../codalt.component';
import { GenericModule } from '../../../../../generic/generic.module';
import { PlanningMaterialsPipe } from '../../../../../pipes/planning-materials.pipe';
import { Utils } from '../../../../../utils.class';
import { getMaterialMarkingKind, MARKING_KIND_LABELS, MarkingKind } from '../../behoefte-overview/behoefte-column.util';
import { LocationFormatPipe } from '../../location-format.pipe';
import { PlanningHighlightService } from '../../planning-highlight.service';

@Component({
    selector: 'app-need-item',
    imports: [CdkDrag, CdkMenuModule, GenericModule, LocationFormatPipe, PlanningMaterialsPipe, CommonModule],
    templateUrl: './need-item.component.html',
    styleUrl: './need-item.component.scss',
})
export class NeedItemComponent extends CodaltComponent implements OnChanges {
    readonly MarkingKindLabels = MARKING_KIND_LABELS;

    @Input() need: Planning;
    @Input() readOnly: boolean;
    @Input() materialsById: Map<number, Material>;
    @Input() contextMenu: TemplateRef<{ need: Planning }>;
    @Input() dateInsteadOfProjectId = false;
    @Input() isCurrent = false;

    @Output() open = new EventEmitter<Planning>();
    @Output() dragEnded = new EventEmitter<CdkDragEnd>();
    @Output() hoverChange = new EventEmitter<number | null>();

    markingKinds: MarkingKind[] = [];
    executeAfterDateUrgency: 'warning' | 'soon' | 'later' = 'later';

    constructor(protected highlightService: PlanningHighlightService) {
        super();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.need || changes.materialsById) {
            const kinds = (this.need.planning_materials ?? [])
                .map(pm => this.materialsById?.get(pm.material_id))
                .map(material => getMaterialMarkingKind(material))
                .filter((kind): kind is MarkingKind => !!kind);

            this.markingKinds = [...new Set(kinds)];
        }

        if (changes.need) {
            this.executeAfterDateUrgency = this.getExecuteAfterDateUrgency();
        }
    }

    private getExecuteAfterDateUrgency(): 'warning' | 'soon' | 'later' {
        if (!this.need.data?.execute_after_date) {
            return 'later';
        }

        const daysUntil = Utils.dayDiff(new Date(), this.need.data.execute_after_date);

        if (daysUntil <= 3) {
            return 'warning';
        }

        if (daysUntil <= 14) {
            return 'soon';
        }

        return 'later';
    }

    onNeedClick(event: MouseEvent) {
        if (this.isCurrent) {
            return;
        }

        if ((event.ctrlKey || event.metaKey) && this.need.mainPlanning?.begindate) {
            const beginDate = new Date(this.need.mainPlanning.begindate);
            const week = Utils.getWeek(beginDate);
            const year = beginDate.getFullYear();

            Utils.openTab(`${environment.feEndpoint}weekplanning/${week}/${year}/${this.need.id}`);

            return;
        }

        this.open.emit(this.need);
    }

    onMoved(event: CdkDragMove) {
        const target = event.source.getRootElement();
        target.style.transform = 'none'; // CDK transform uitschakelen
        target.style.position = 'fixed';
        target.style.left = event.pointerPosition.x + 'px';
        target.style.top = event.pointerPosition.y + 'px';
    }
}
